import type { OrganisationAnalyticsShowResponse } from '@jobilla/nexus-sdk'
import { format } from 'date-fns'

export type CampaignRow = OrganisationAnalyticsShowResponse['breakdown']['data'][number]

export function targetAreaLabel(row: CampaignRow): string | null {
	const names = row.targetedAreas.map((area) => area.name).join(', ')
	if (!names || names === row.location) { return null }
	return names
}

export function periodLabel(row: CampaignRow): string | null {
	if (!row.startDate && !row.endDate) { return null }
	const fmt = (date: string | null) => {
		if (!date) { return '…' }
		const [year, month, day] = date.slice(0, 10).split('-').map(Number)
		return format(new Date(year, month - 1, day), 'd MMM yyyy')
	}
	return `${fmt(row.startDate)} – ${fmt(row.endDate)}`
}
